import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "@vahak/core/dist/_services/firebase.service";
import { PRODUCTION_ENV } from "@vahak/core/dist/constants";
import { PlivoRemoteInfo } from "../../context/call/type";

interface IRealtimeBidUpdates {
    mpcName: string;
    enabled: boolean;
    onUpdate?: (data: PlivoRemoteInfo[]) => void;
}

const useRealtimeCallInfo = ({ mpcName, enabled, onUpdate }: IRealtimeBidUpdates) => {
    const [data, setData] = useState<PlivoRemoteInfo[]>([]);

    useEffect(() => {
        if (!enabled || !mpcName) {
            setData([]);
            return;
        }

        const env = process.env.NEXT_PUBLIC_REACT_APP_ENV === PRODUCTION_ENV ? "prod" : "dev";

        const colRef = collection(db, "conference_call_status", env, mpcName);

        const unsubscribe = onSnapshot(colRef, (snapshot) => {
            if (snapshot.empty) {
                setData([]);
                return;
            }

            const docs = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data()
            }));

            setData(docs);
            onUpdate?.(docs);
        });

        return () => {
            unsubscribe();
            setData([]);
        };
    }, [mpcName, enabled]);

    return { data };
};

export default useRealtimeCallInfo;
